import type React from 'react';
import {
  Award, BarChart3, Bell, BookOpen, CalendarCheck, CalendarClock, CalendarX2,
  CheckCircle2, ClipboardCheck, Clock, Coins, Gift, GraduationCap, Hand, Heart, Lightbulb, ListChecks,
  Megaphone, MessageSquare, MessageSquarePlus, MessageSquareWarning, Mic, PlayCircle, Presentation, Share2, Shield, Star,
  TrendingUp, UserCheck, UserMinus, Users, XCircle,
} from 'lucide-react';

// Kept in step with NotificationTypes.java on the backend: anything emitted there and
// missing here falls back to a plain bell, which makes a busy list unreadable at a glance.
export const NOTIF_ICONS: Record<string, React.ElementType> = {
  // Events
  event_shared: Share2,
  event_rsvp: CalendarCheck,
  event_rsvp_confirmed: CheckCircle2,
  event_reminder: CalendarClock,
  event_reminder_1d: CalendarClock,
  event_reminder_5d: CalendarClock,
  event_nudge: CalendarClock,
  event_modified: CalendarClock,
  event_cancelled: CalendarX2,
  new_event: CalendarCheck,
  event_review_requested: ClipboardCheck,
  event_approved: CheckCircle2,
  event_rejected: XCircle,
  event_changes_requested: MessageSquareWarning,
  event_feedback_request: Star,
  feedback_request: Star,
  event_waitlist: ListChecks,
  event_waitlist_promoted: CheckCircle2,
  speaker_request_reviewed: Mic,
  speaker_invited: Mic,
  speaker_invitation_answered: Mic,
  event_owner_assigned: UserCheck,
  event_attendee_removed: UserMinus,
  event_comment: MessageSquare,
  // Learning
  mandatory_enrolled: BookOpen,
  mandatory_reminder: Clock,
  mandatory_reminder_7d: Clock,
  mandatory_reminder_1d: Clock,
  course_enrolled: BookOpen,
  course_withdrawn: XCircle,
  quiz_attempts_reset: BookOpen,
  course_completed: Award,
  certificate_issued: GraduationCap,
  certificate_revoked: GraduationCap,
  certificate_waiting: GraduationCap,
  certificate_expiring: GraduationCap,
  pending_rating: Star,
  // Kudos and recognition
  kudos_received: Heart,
  kudos_reaction: Hand,
  kudos_comment: MessageSquare,
  kudos_review_requested: ClipboardCheck,
  kudos_reviewed: CheckCircle2,
  badge_earned: Award,
  level_up: TrendingUp,
  // Points
  points_adjusted: Coins,
  points_frozen: Shield,
  points_expiring: Coins,
  points_expired: Coins,
  redemption_update: Gift,
  points_approval_needed: Coins,
  points_flag: Shield,
  redemption_requested: Gift,
  use_case_review: Lightbulb,
  use_case_decided: Lightbulb,
  proposal_submitted: MessageSquarePlus,
  contribution_to_decide: MessageSquarePlus,
  proposal_decided: MessageSquarePlus,
  recording_review: PlayCircle,
  recording_decided: PlayCircle,
  // Admin and org
  admin_broadcast: Megaphone,
  broadcast: Megaphone,
  poll: BarChart3,
  poll_reminder: BarChart3,
  user_approved: UserCheck,
  new_member: Users,
  low_enrollment: Users,
  account_status: Shield,
  role_changed: Shield,
  // Workshops
  workshop_recap_48h: Presentation,
  workshop_day7_followup: ListChecks,
};

export function getNotifConfig(type: string): { Icon: React.ElementType } {
  return { Icon: NOTIF_ICONS[type] || Bell };
}
